import InternalAPI from "@/app/axios"

export default class CareerRepository extends InternalAPI {
  constructor() {
    super();
    /** @type {string} */
    this.employeeBrandingEndpoint = '/v1/employee_branding'
  }

  async getAll(param) {
    try {
      const res = await this.$axios.get(this.employeeBrandingEndpoint + '/data?'+param)
      if (res.status === 200) {
        if (res.data) {
          return {data: res.data, err: null}
        }
      }
      return {data: null, err: null}
    } catch (err) {
      return {data: null, err: this.setErrorMessage(err.response?.data?.desc?.en || err.response?.data?.message?.en)}
    }
  }

  async getDetail(id) {
    try {
      const res = await this.$axios.get(this.employeeBrandingEndpoint + '/' + id)
      if (res.status === 200) {
        if (res.data) {
          return {data: res.data, err: null}
        }
      }
      return {data: null, err: null}
    } catch (err) {
      return {data: null, err: this.setErrorMessage(err.response?.data?.desc?.en || err.response?.data?.message?.en)}
    }
  }

  async create(payload) {
    try {
      const res = await this.$axios.post(this.employeeBrandingEndpoint, payload)
      if (res.status === 201 || res.status === 200) {
        if (res.data) {
          return {data: res.data, err: null}
        }
      }
      return {data: null, err: null}
    } catch (err) {
      return {data: null, err: this.setErrorMessage(err.response?.data?.desc?.en || err.response?.data?.message?.en)}
    }
  }
  async edit(id, payload) {
    try {
      const res = await this.$axios.put(this.employeeBrandingEndpoint + '/' + id, payload)
      if (res.data) {
        return {data: res.data, err: null}
      }     
      return {data: null, err: null}
    } catch (err) {
      return {data: null, err: this.setErrorMessage(err.response?.data?.desc?.en || err.response?.data?.message?.en)}
    }
  }
}
